import cls from 'classnames';
import styles from './index.module.scss';
import type { DialogProps } from './interface';

const Dialog = ({
  title,
  content,
  onConfirm,
  onCancel,
  centered,
  showCancel = true,
  showConfirm = true,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  confirmClassName,
  ...restProps
}: DialogProps) => {
  let instance: ReturnType<typeof Modal.confirm> | null = null;
  const handleConfirm = async () => {
    try {
      await onConfirm?.();
    } finally {
      instance?.destroy();
    }
  };

  const handleCancel = async () => {
    try {
      await onCancel?.();
    } finally {
      instance?.destroy();
    }
  };

  instance = Modal.confirm({
    title: null,
    icon: null,
    centered,
    width: 295,
    styles: {
      content: {
        padding: 0,
        margin: 'auto',
      },
    },
    content: (
      <div className={styles.dialog}>
        <div className={styles.title}>{title}</div>
        <div className={styles.content}>{content}</div>
        <div className={styles.actions}>
          {showCancel && (
            <div className={cls(styles.button, styles.cancel)} onClick={handleCancel}>
              {cancelText}
            </div>
          )}

          {showConfirm && (
            <div
              className={cls(styles.button, styles.confirm, confirmClassName)}
              onClick={handleConfirm}
            >
              {confirmText}
            </div>
          )}
        </div>
      </div>
    ),
    footer: null,
    ...restProps,
  });
  return instance;
};

export default Dialog;
